export function sanitizeSingleFields(obj, fields = []) {
  const sanitizedObj = {};
  fields.forEach((v) => {
    if (obj[v] !== undefined) {
      sanitizedObj[v] = obj[v];
    }
  });
  return sanitizedObj;
}
